module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#user",
      toString: function () {
        return this.url;
      }
    }